import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { I18nPipe } from '../../../shared/i18n/i18n-pipe';
import { I18nScopeReadyDirective } from '../../../shared/i18n/i18n-scope-ready.directive';
import { provideI18nScope } from '../../../shared/i18n/i18n-scope.provider';
import { I18nScopedService } from '../../../shared/i18n/i18n-scoped.service';

@Component({
  selector: 'app-add-custom-view-dialog',
  imports: [
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    I18nPipe,
    I18nScopeReadyDirective,
  ],
  providers: [
    provideI18nScope('ui/custom-view/add-custom-view-dialog'),
    I18nScopedService,
  ],
  templateUrl: './add-custom-view-dialog.html',
  styleUrl: './add-custom-view-dialog.scss',
})
export class AddCustomViewDialog {
  private readonly dialogRef = inject(MatDialogRef<AddCustomViewDialog>);

  name = '';

  apply(): void {
    if (!this.name.trim()) return;
    this.dialogRef.close(this.name.trim());
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
